import {useEffect} from 'react';
import {
  getQueryStringParameters,
} from '../utils/commonMethods';
import dynamicLinks from '@react-native-firebase/dynamic-links';

import {deepLinkConst, deeplinkTabs} from './dynamicLinkConst';
import {useDispatch} from 'react-redux';
import {Network} from '../utils/network';
import {getCurrentRoute, navigate} from '../navigation/rootNavigation';
import {
  TabActions,
  useNavigation,
  useNavigationState,
} from '@react-navigation/native';
import {
  checkOtpLessRedirection,
  setHomeFilterCategory,
} from '../screens/home/redux/home.action';
import {globalImport} from './globalImports';
import AsyncStorage from '@react-native-async-storage/async-storage';

const useDynamicLink = (
  navigation,
  setInitialDynamicLink,
  isInitialDynamicLinkFired,
) => {
  const dispatch = useDispatch();

  const setupInitialLink = async (
    setInitialDynamicLink,
    isInitialDynamicLinkFired,
  ) => {
    try {
      if (!isInitialDynamicLinkFired) {
        const url = await dynamicLinks().getInitialLink();
        console.log('======', url);
        if (url) {
          handleDynamicLink(url);
          setInitialDynamicLink(true);
        }
      }
    } catch (e) {}
  };

  const handleDynamicLink = async link => {
    try {
      const queryStringArray = getQueryStringParameters(link.url);
      if (queryStringArray) {
        if (queryStringArray['eventtype']) {
          if (queryStringArray['referredBy']) {
            const token = await AsyncStorage.getItem('token');
            if (token) {
              const config = {
                headers: {
                  Authorization: token,
                },
              };
              Network.referEvent(
                {
                  referredBy: queryStringArray['referredBy'],
                  eventId: queryStringArray['probeid'],
                },
                config,
              );
            }
          }
          const internalEvent = {id: queryStringArray['probeid']};
          if (getCurrentRoute() === 'Event') {
            navigation.pop();
          }
          navigation.navigate('Event', {
            eventId: internalEvent?.id,
            isMulti: internalEvent?.parent_id === -1 ? true : false,
          });
          //navigation.navigate("Event", { eventData: internalEvent });
        } else if (queryStringArray['category']) {
          dispatch(setHomeFilterCategory(queryStringArray['category']));
        } else if (deeplinkTabs.includes(queryStringArray['page'])) {
          const jumpToAction = TabActions.jumpTo(
            deepLinkConst[queryStringArray['page']],
          );
          navigation.navigate('Home');
          navigation.dispatch(jumpToAction);
        } else if (queryStringArray?.hashtag) {
          const spliArr = '#' + queryStringArray?.hashtag;
          //const internalEvent = atob(spliArr);
          navigation.navigate('HashTag', {hash_tag: spliArr});
        } else if (deepLinkConst[queryStringArray['page']]) {
          const pageObj = deepLinkConst[queryStringArray['page']];
          if (pageObj.child) {
            navigation.navigate(pageObj.parent, {screen: pageObj.child});
          } else {
            if (pageObj.parent) {
              navigation.navigate(pageObj.parent);
            } else {
              navigation.navigate(pageObj);
            }
          }
        } else if (queryStringArray['club_id'] && queryStringArray['eventId']) {
          navigation.navigate('ClubStack', {
            screen: 'ClubMarketDetail',
            params: {
              clubId: queryStringArray['club_id'],
              eventId: queryStringArray['eventId'],
            },
          });
        } else if (queryStringArray['club_id']) {
          navigation.navigate('ClubStack', {
            screen: 'ClubMarkets',
            params: {club_id: queryStringArray['club_id']},
          });
        } else if (queryStringArray['session_id']) {
          if (getCurrentRoute() === 'Login') {
            navigation.pop();
          }

          dispatch(checkOtpLessRedirection(queryStringArray['session_id']));
        }
      } else {
        if (link?.url.includes('Fantasy') && link?.url.includes('false')) {
          const a = link?.url.split('/');
          if (a?.length) {
            navigation.navigate('Fantasy', {
              screen: 'ContestEvents',
              params: {
                contestId: a[a.length - 3],
                eventId: +a[a.length - 2],
                isMulti: false,
              },
            });
          }
        } else if (link?.url.includes('Fantasy')) {
          const a = link?.url.split('/');
          if (a?.length) {
            navigation.push('Fantasy', {
              screen: 'contestDetail',
              params: {contestId: a[a.length - 1]},
            });
          }
        }
      }
    } catch (e) {}
  };

  useEffect(() => {
    if (!globalImport.isWeb) {
      const unsubscribe = dynamicLinks().onLink(handleDynamicLink);
      // When the component is unmounted, remove the listener

      setupInitialLink(setInitialDynamicLink, isInitialDynamicLinkFired);
      return () => unsubscribe();
    }
  }, []);
};

export default useDynamicLink;
